import { render, staticRenderFns } from "./UnidadeParceiraDetalhes.vue?vue&type=template&id=6e51befb"
import script from "./UnidadeParceiraDetalhes.vue?vue&type=script&lang=js"
export * from "./UnidadeParceiraDetalhes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports